import { render } from "./EmailInject.vue?vue&type=template&id=ab4d0224"
import script from "./EmailInject.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailInject.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/checkout/injectComponents/EmailInject.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab4d0224"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab4d0224', __exports__)) {
    api.reload('ab4d0224', __exports__)
  }
  
  module.hot.accept("./EmailInject.vue?vue&type=template&id=ab4d0224", () => {
    api.rerender('ab4d0224', render)
  })

}


export default __exports__